import axios from 'axios';
import { toast } from 'react-toastify';
import { API_URL } from '../../../../lib/const';


const fetchOnboardings = (params = {}) => (
  axios.get(`${API_URL}/onboardings`, { params })
    .then(response => response.data)
);

export const fetchOnboarding = (params = {}) => (
  axios.get(`${API_URL}/onboarding/onboardings`, { params })
    .then(response => {
      if(response.status != 200){
        return toast.error('Ocorreu um erro')
      }
        return response.data[0]
    })
);

export default fetchOnboardings;
